/**
 * React Query stale times for the World Cup domain.
 * Keep windows wide enough that switching Picks ↔ Leaderboard ↔ Squads reuses cache
 * instead of refiring APIs on every remount (router.replace unmounts each screen).
 * Mutations still invalidate affected queries for fresh scores.
 */

/** Leaderboard + groups: tab switches should not refetch every few seconds. */
export const STALE_TIME_WORLD_CUP_LEADERBOARD_MS = 3 * 60 * 1000;

/** Matches / picks payload + tournament standings: same tab-switch behavior. */
export const STALE_TIME_WORLD_CUP_MATCHES_MS = 3 * 60 * 1000;

/** Keep World Cup query cache warm across route/tab switches. */
export const GC_TIME_WORLD_CUP_MS = 10 * 60 * 1000;

/** Delay speculative tab prefetch to avoid startup request spikes. */
export const WORLD_CUP_PREFETCH_DELAY_MS = 2000;

/** Stagger delay between sequential prefetch requests to avoid server request burst. */
export const WORLD_CUP_INTER_PREFETCH_DELAY_MS = 450;
